import React from 'react';
import { Lightning, RocketLaunch, StopCircle, FolderOpen, UserCircle, SignIn, SignOut } from '@phosphor-icons/react';
import OperationalStatusBadge from '@/components/OperationalStatusBadge';
import { OPERATIONAL_STATUS } from '@/constants/operationalTruth';
import { useAuth } from '@/context/AuthContext';

const OrchestratorHeaderBar = ({
  isOrchestratorActive,
  onToggleOrchestrator,
  onDeployMission,
  onStopMission,
  activeProject,
  onOpenProjectWorkspace
}) => {
  const { user, isAuthenticated, openAuthModal, logout } = useAuth();

  return (
    <div className={`w-full transition-all duration-300 ${isOrchestratorActive ? 'bg-[#13131A] border-b border-[#D97706]/40 py-2 px-6' : 'bg-[#0A0C10] border-b border-[#1F2937] py-1.5 px-6'} flex items-center justify-between text-xs font-mono select-none`}>
      <div className="flex items-center gap-3">
        {/* Manage Projects Button */}
        <button
          onClick={onOpenProjectWorkspace}
          className="flex items-center gap-2 px-3 py-1 bg-[#13131A] text-[#00E5FF] border border-[#00E5FF]/40 hover:bg-[#00E5FF]/10 font-bold transition-all shadow-sm rounded"
          title="Abrir Project Workspace (Mission 10/11)"
        >
          <FolderOpen className="w-4 h-4 text-[#00E5FF]" />
          <span>Manage Projects</span>
          {activeProject ? (
            <span className="text-[10px] px-1.5 py-0.2 bg-[#00E5FF]/20 text-[#00E5FF] rounded border border-[#00E5FF]/40 truncate max-w-[150px]">
              {activeProject.name}
            </span>
          ) : (
            <span className="text-[10px] text-[#6B7280] font-normal">
              (Ninguno)
            </span>
          )}
        </button>

        <button
          onClick={onToggleOrchestrator}
          className={`flex items-center gap-2 px-3 py-1 border font-semibold transition-all shadow-sm rounded ${
            isOrchestratorActive
              ? 'bg-[#D97706]/20 text-[#D97706] border-[#D97706]/50'
              : 'bg-[#13131A] text-[#9CA3AF] border-[#1F2937] hover:bg-[#1C1C24] hover:text-[#F3F4F6]'
          }`}
        >
          <Lightning className={`w-4 h-4 ${isOrchestratorActive ? 'text-[#D97706] animate-pulse' : 'text-[#9CA3AF]'}`} />
          {isOrchestratorActive ? 'Modo Orquestador UI (Prototipo)' : 'Modo Orquestador UI'}
        </button>

        <OperationalStatusBadge status={OPERATIONAL_STATUS.STATIC} size="sm" />

        {isOrchestratorActive && (
          <span className="text-[#9CA3AF] text-[11px] hidden md:inline-flex items-center gap-2 terminal-font">
            <span className="w-2 h-2 rounded-full bg-[#D97706]" />
            Orchestrator UI Prototype — Demostración visual de control agéntico local
          </span>
        )}
      </div>

      <div className="flex items-center gap-2">
        {isOrchestratorActive && (
          <div className="flex items-center gap-2 mr-2">
            <button
              onClick={onDeployMission}
              className="flex items-center gap-1.5 px-3 py-1 bg-[#10B981]/10 hover:bg-[#10B981]/20 text-[#10B981] border border-[#10B981]/40 font-medium transition-all rounded"
            >
              <RocketLaunch className="w-3.5 h-3.5 text-[#10B981]" /> Desplegar Misión
              <OperationalStatusBadge status={OPERATIONAL_STATUS.DEMO} size="sm" />
            </button>
            <button
              onClick={onStopMission}
              className="flex items-center gap-1.5 px-3 py-1 bg-[#F85149]/10 hover:bg-[#F85149]/20 text-[#F85149] border border-[#F85149]/40 font-medium transition-all rounded"
            >
              <StopCircle className="w-3.5 h-3.5 text-[#F85149]" /> Detener
              <OperationalStatusBadge status={OPERATIONAL_STATUS.DEMO} size="sm" />
            </button>
          </div>
        )}

        {/* Identity Indicator */}
        {isAuthenticated && user ? (
          <div className="hidden lg:flex items-center gap-1.5 text-[11px] text-[#A7F3D0] px-2 py-0.5 bg-[#064E3B]/30 border border-[#10B981]/40 rounded">
            <UserCircle className="w-3.5 h-3.5 text-[#10B981]" />
            <span className="truncate max-w-[120px]">{user.display_name || user.email}</span>
          </div>
        ) : (
          <button
            onClick={openAuthModal}
            className="flex items-center gap-1 px-2 py-0.5 bg-[#00E5FF]/10 text-[#00E5FF] hover:bg-[#00E5FF]/20 border border-[#00E5FF]/40 rounded transition-all text-[11px]"
          >
            <SignIn className="w-3.5 h-3.5" />
            <span>Sign In</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default OrchestratorHeaderBar;
